import { render, staticRenderFns } from "./all-admin.vue?vue&type=template&id=df088aae&scoped=true&"
import script from "./all-admin.vue?vue&type=script&lang=js&"
export * from "./all-admin.vue?vue&type=script&lang=js&"
import style0 from "./all-admin.vue?vue&type=style&index=0&id=df088aae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df088aae",
  null
  
)

export default component.exports